module.exports = __webpack_public_path__ + "img/rondouvre.0b9a9d81.svg";